import { RegistroMChatAcompanhamentoPuericultura } from '../../../aside/acompanhamento-puericultura/model'
import { convertAplicacaoQueryToPerguntaRespostaInput } from './consulta-seguimento/converter-consultaSeguimento'
import { ConsultaSeguimentoViewModel } from './consulta-seguimento/model-consultaSeguimento'
import { MchatRfAplicacaoQueryModel } from './model-mChatRf'

export function isAccordionPreExpanded({
  ageInMonths,
  ageInMonthsAtendimentoAnterior,
  hasValuesAtendimentoAnterior,
  isMChatAnteriorRiscoBaixo,
}: {
  ageInMonths: number | undefined
  ageInMonthsAtendimentoAnterior: number | undefined
  hasValuesAtendimentoAnterior: boolean
  isMChatAnteriorRiscoBaixo: boolean
}) {
  if (!ageInMonths || !ageInMonthsAtendimentoAnterior) {
    return false
  }

  if (ageInMonths >= 16 && !hasValuesAtendimentoAnterior) {
    return true
  }
  if (hasValuesAtendimentoAnterior && isMChatAnteriorRiscoBaixo) {
    return !(ageInMonths < 24 || ageInMonthsAtendimentoAnterior > 24)
  }
  return false
}

export function buildConsultaSeguimentoStats(
  item: RegistroMChatAcompanhamentoPuericultura
): ConsultaSeguimentoViewModel {
  const totalPerguntasRespondidas = new Set(
    item.aplicacao.map((p: MchatRfAplicacaoQueryModel) => p.pergunta.match(/PERGUNTA_(\d+)_/)?.[1]).filter(Boolean)
  ).size

  const totalPerguntasFalhou = item.pontuacao

  const totalPerguntasPassou = totalPerguntasRespondidas - totalPerguntasFalhou

  return {
    totalPerguntasRespondidas,
    totalPerguntasFalhou,
    totalPerguntasPassou,
    resultado: item.risco,
    aplicacao: convertAplicacaoQueryToPerguntaRespostaInput(item.aplicacao),
  }
}
